;(function() {
    const ajaxHTML = CommentsLsAjaxHTML();
    const ajaxCRUD = CommentsLsAjaxCRUD();
    const DOMDisplay = CommentsLsDOMDisplay();
    const ToggleVisible = CommentsLSToggleVisible();

    const commentBody = $(".comments"),
        list = commentBody.find(".comment-list");

    list.on("click", function(event) {
        const target = $(event.target);
        const isElementWithoutActions = $._data(target[0]).events === undefined;

        if (target.attr("data-btn-type") === "cancel-update") {
            cancelUpdateComment(target);
        } else if (target.attr("data-btn-type") === "cancel-answer") {
            cancelAnswerComment(target);
        } else if (target.attr("id") === "new-comment-message" && isElementWithoutActions) {
            const form = list.find("form");
            const currentForm = $(event.target).closest("form"),
                fieldName = currentForm.find("#new-comment-name"),
                fieldEmail = currentForm.find("#new-comment-email");
            target.on("input", function () {
                ToggleVisible.fields(event.target.value, [fieldName, fieldEmail]);
                disabledOrEnabledSubmit(target);
            });
            form.on("submit", function(event) {
                event.preventDefault();
                ajaxCRUD.update(form);
            });
        }
    });

    function cancelAnswerComment(target) {
        const bodyContainer = target.closest("ul"),
            parentComment = target.closest(".comment-list").find(`[data-id=${target.attr("data-parent-id")}]`),
            buttonAnswer = parentComment.find('[data-type=answer]');

        DOMDisplay.show(buttonAnswer);
        bodyContainer.remove();
    }

    function cancelUpdateComment(target) {
        const form = target.closest("form"),
            id = form.find("#new-comment-id").val(),
            bodyContainer = target.closest(".comment");

        ajaxHTML.insertComment(bodyContainer, id);
    }

    function disabledOrEnabledSubmit(target) {
        const buttonSubmit = target.closest("form").find("button[type=submit]");

        if (target.val() !== '') {
            buttonSubmit.prop("disabled", false);
        } else {
            buttonSubmit.prop("disabled", true);
        }
    }
}());
